





















import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Footer from '@/views/layout/Footer.vue';
import Header from '@/views/layout/Header.vue';
import ErrorDisplay from '@/views/layout/ErrorDisplay.vue';
import MobileHeader from '@/views/layout/MobileHeader.vue';
import KeycloakStore from '@/stores/user/keycloak.store';
import UserStore from '@/stores/user/user.store';
import ShopStore from '@/stores/shop.store';
import { EventKey } from '@/util/EventKey';
import CookieNotice from '@/views/common/CookieNotice.vue';
import { fetchGA4, fetchGoogleTagManager } from '@/fetchGoogleTagManager';

@Component({
  components: {
    CookieNotice,
    MobileHeader,
    ErrorDisplay,
    Header,
    Footer,
  },
})
export default class App extends Vue {
  private keycloakStore = getModule(KeycloakStore, this.$store);
  private userStore = getModule(UserStore, this.$store);
  private shopStore = getModule(ShopStore, this.$store);

  public async mounted(): Promise<void> {
    if (document.cookie.indexOf('gm-cookies') >= 0) {
      fetchGoogleTagManager();
      fetchGA4();
    }

    await this.shopStore.fetchShopSettings();
    await this.keycloakStore.initialize();
    if (this.keycloakStore.authenticated) {
      await this.initAuthenticated();
    } else {
      await this.initGuest();
    }
  }

  private async initAuthenticated(): Promise<void> {
    const userResponse = await this.userStore.fetchUserOnce();
    if (!userResponse.success) {
      await this.userStore.applyLanguageFromLocalStorage();
    }
    await this.userStore.markLanguageExplicitlySet();
    this.$events.$emit(EventKey.INITIAL_LANGUAGE, this.userStore.currentLanguage);
  }

  private async initGuest() {
    await this.userStore.applyLanguageFromLocalStorage();
    await this.userStore.markLanguageExplicitlySet();
    this.$events.$emit(EventKey.INITIAL_LANGUAGE, this.userStore.currentLanguage);
  }

  public handleCanvasClick() {
    this.$events.$emit(EventKey.MAIN_CANVAS_CLICK);
  }

  public isIE(): boolean {
    const userAgent = navigator.userAgent;
    return userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
  }

  get duringRegistration() {
    return this.$route.matched.some((record) => record.meta.isRegisterHeader);
  }

  get isAccentBackground() {
    return this.$route.matched.some((record) => record.meta.checkoutHeader || record.meta.accentBackground);
  }
}
